import request from '@/utils/request'

export function fetchJobChangeList(query) {
    return request({
        url: '/admin/person/change/job/list',
        method: 'get',
        params: query
    })
}

export function delJobChange(data) {
    return request({
        url: '/admin/person/change/job/delete',
        method: 'post',
        data
    })
}

export function fetchDepartmentChangeList(query) {
    return request({
        url: '/admin/person/change/department/list',
        method: 'get',
        params: query
    })
}

export function delDepartmentChange(data) {
    return request({
        url: '/admin/person/change/department/delete',
        method: 'post',
        data
    })
}

//accommodation
export function fetchAccommodationChangeList(query) {
    return request({
        url: '/admin/person/change/accommodation/list',
        method: 'get',
        params: query
    })
}

export function delAccommodationChange(data) {
    return request({
        url: '/admin/person/change/accommodation/delete',
        method: 'post',
        data
    })
}

//car
export function fetchCarChangeList(query) {
    return request({
        url: '/admin/person/change/car/list',
        method: 'get',
        params: query
    })
}

export function delCarChange(data) {
    return request({
        url: '/admin/person/change/car/delete',
        method: 'post',
        data
    })
}

//insure
export function fetchInsureChangeList(query) {
    return request({
        url: '/admin/person/change/insure/list',
        method: 'get',
        params: query
    })
}

export function delInsureChange(data) {
    return request({
        url: '/admin/person/change/insure/delete',
        method: 'post',
        data
    })
}

//meal
export function fetchMealChangeList(query) {
    return request({
        url: '/admin/person/change/meal/list',
        method: 'get',
        params: query
    })
}

export function delMealChange(data) {
    return request({
        url: '/admin/person/change/meal/delete',
        method: 'post',
        data
    })
}

//performance
export function fetchPerformanceChangeList(query) {
    return request({
        url: '/admin/person/change/performance/list',
        method: 'get',
        params: query
    })
}

export function delPerformanceChange(data) {
    return request({
        url: '/admin/person/change/performance/delete',
        method: 'post',
        data
    })
}
